import validator from 'validator';

const validationRules = [
  {
    field: 'start_date',
    method: validator.isEmpty,
    validWhen: false,
    dependency: { field: 'periode', value: [ 'Hari', 'Bulan', 'Tahun' ] },
    message: 'perlu diisi..',
  },
  {
    field: 'end_date',
    method: validator.isEmpty,
    validWhen: false,
    dependency: { field: 'periode', value: [ 'Hari', 'Bulan', 'Tahun' ] },
    message: 'perlu diisi..',
  },
  {
    field: 'start_date',
    method: validator.equals,
    args: [ 'Invalid date' ],
    validWhen: false,
    dependency: { field: 'periode', value: [ 'Hari', 'Bulan', 'Tahun' ] },
    message: 'perlu diisi..',
  },
  {
    field: 'end_date',
    method: validator.equals,
    args: [ 'Invalid date' ],
    validWhen: false,
    dependency: { field: 'periode', value: [ 'Hari', 'Bulan', 'Tahun' ] },
    message: 'perlu diisi..',
  },
  {
    field: 'start_age',
    method: validator.isEmpty,
    validWhen: false,
    dependency: { field: 'age_group', value: [ 'Hari', 'Bulan', 'Tahun' ] },
    message: 'perlu diisi..',
  },
  {
    field: 'end_age',
    method: validator.isEmpty,
    validWhen: false,
    dependency: { field: 'age_group', value: [ 'Hari', 'Bulan', 'Tahun' ] },
    message: 'perlu diisi..',
  },
];

export default validationRules;
